import type { ContentNugget } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set([
  'slug',
  'media_id',
  'media',
  'preview_media_id',
  'preview_media',
  'created_by_user_id',
  'createdByUser',
  'sponsor_id',
  'is_browsable',
]);

export const useAgentContext = (nugget?: ContentNugget | null) => {
  useRegisterAgentContext(
    nugget
      ? {
          kind: 'entity',
          description: 'The content nugget the user is viewing',
          data: Object.fromEntries(Object.entries(nugget).filter(([k]) => !EXCLUDED_KEYS.has(k))),
        }
      : null,
  );
};
